import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=5e276e83&scoped=true&"
import script from "./risk.vue?vue&type=script&lang=js&"
export * from "./risk.vue?vue&type=script&lang=js&"
import style0 from "./risk.vue?vue&type=style&index=0&id=5e276e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e276e83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e276e83')) {
      api.createRecord('5e276e83', component.options)
    } else {
      api.reload('5e276e83', component.options)
    }
    module.hot.accept("./risk.vue?vue&type=template&id=5e276e83&scoped=true&", function () {
      api.rerender('5e276e83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/risk.vue"
export default component.exports